import axios from "axios";
import { v4 as uuid } from "uuid";
import { TokenService } from "../lib/TokenService";
import axiosRetry from "axios-retry";
import { showErrorToast } from "../lib/toast";

const fraudInvestigationServerUrl = window.INVESTIGATION_SERVER_URL

export const axiosInstance = axios.create({
    baseURL: fraudInvestigationServerUrl,
    headers: {'Content-Type': 'application/json'},
    timeout: 60000
})

axiosInstance.interceptors.request.use((config) => {
    const correlation_id = uuid();
    config.headers['correlation-id'] = correlation_id;
    
    const token = TokenService.getCansoToken();
    if(token)
        config.headers['Authorization'] = `Bearer ${token}`;
    return config;
});

axiosRetry(axiosInstance, {retries: 3})

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      showErrorToast("Access Denied.");
    }
    return Promise.reject(error);
  }
);

export class APIError  extends Error{
    constructor(message: string){
        super(message);
        this.name = "APIError"
        Object.setPrototypeOf(this, APIError.prototype); 
    }
}

export interface OptionValues {
    name: string
    values: string[]
}

export interface MessageResponse {
    message: string
}